<template>
  <div class="scroll_content">
    <Headbgm />
    <div>
      <div class="red_open">
        <div class="send_user">LUCKY RED PACKAGE</div>
        <div class="issue_no">Current issue no {{ red_issue_no }}</div>
        <div class="head_img">
          <img src="@/assets/images/game/red/indo1.png" />
        </div>
        <div class="openning" v-show="openning">
          <img src="@/assets/images/game/red/coin_turn.gif" />
        </div>
        <div class="red_no_open" v-show="red_open">
          <div class="may_you">{{ plan.red_title }}</div>
          <div class="open" v-show="!openning" @click="grabRed()">OPEN</div>
        </div>
        <div class="red_win" v-show="red_win">
          <div class="may_you">{{ grabInfo }}</div>
          <div class="win_money">₹{{ money }}</div>
          <div class="win_tip" v-show="already">
            <div class="t1">Open Already</div>
            <div class="t2">{{ grabTime }}</div>
          </div>
          <div class="show_more" @click="showMore(true)" v-if="!isPC">
            See the details of the award >
          </div>
        </div>
        <div class="red_no_win" v-show="red_no_win">
          <div class="may_you">{{ grabInfo }}</div>
          <div class="show_more" @click="showMore(true)" v-if="!isPC">
            Look at everyone's luck >
          </div>
        </div>
        <div class="company">
          The red package redemption right belongs to Coin Switch, Please
          contact administrator for redemption
        </div>
      </div>
    </div>
    <div :class="isPC ? 'game_right' : 'game_right_m'">
      <div class="close-btn" @click="showMore(false)" v-if="!isPC">
        <img src="@/assets/images/base/close_black_big.png" />
      </div>
      <div class="right_title">Red Package Openning Records</div>
      <div class="right_list">
        <ul v-for="item in plays" v-bind:key="item.id">
          <li class="record-img">
            <img src="@/assets/images/game/red/red_record.png" />
          </li>
          <li class="red-from">
            <div>{{ item.user_name }}-{{ item.ip_adds }}</div>
            <div>{{ item.grab_time }}</div>
          </li>
          <li class="red-money">+{{ item.money }}</li>
        </ul>
      </div>
    </div>
    <div class="box_shadow" v-show="showloding">
      <van-loading size="100px" color="#d04e18" vertical></van-loading>
    </div>
    <!-- 声音 -->
    <div style="display: none">
      <audio id="Staropen">
        <source src="@/assets/music/red/red_open.mp3" type="audio/mpeg" />
      </audio>
    </div>
    <FootGame />
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import Headbgm from "@/coms/headbgm.vue";
import FootGame from "@/coms/footgame.vue";
/*global mui,$*/
export default {
  components: {
    Headbgm,
    FootGame,
  },
  data() {
    return {
      isPC: this.util.isPC(),
      openning: false,
      red_open: true,
      showloding: false,
      red_no_win: false,
      red_win: false,
      red_issue_no: "",
      plan: {},
      plays: [],
      money: 0,
      already: false,
      grabTime: "",
      grabInfo: "",
    };
  },
  methods: {
    showMore(flag) {
      if (flag) $(".game_right_m").show();
      else $(".game_right_m").hide();
    },
    findConfigs() {
      let _this = this;
      this.showloding = true;
      this.axios.get(this.api.api_findConfigs, {
          params: { names: "red_issue_no" },
        })
        .then((res) => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.red_issue_no = res.data.data.red_issue_no;
          }
        })
        .catch(() => {
          _this.showloding = false;
          _this.throttle = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    findLastRed() {
      let _this = this;
      this.showloding = true;
      this.axios.get(this.api.api_findLastRed, null).then((res) => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.plan = res.data.data.plan;
            this.plays = res.data.data.plays.map((item) => {
              return {
                user_name: item.user_name,
                money: item.money,
                ip_adds: item.ip_adds,
                grab_time: this.util.formatTimeEn(item.grab_time),
              };
            });
          }
        })
        .catch(() => {
          _this.showloding = false;
          _this.throttle = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
    grabRed() {
      let _this = this;
      this.openning = true;
      this.axios.post(this.api.api_grabRed, null).then((res) => {
          setTimeout(function () {
            _this.findLastRed();
            if (res.data.code == 0) {
              _this.money = res.data.data.money;
              _this.openning = false;
              _this.red_open = false;
              _this.red_win = true;
              _this.grabInfo = res.data.data.msg;
              if (res.data.data.code == 1) {
                _this.already = true;
                _this.grabTime = _this.util.formatTimeEn(
                  res.data.data.grabTime
                );
              } else {
                document.getElementById("Staropen").play();
              }
            } else {
              _this.openning = false;
              _this.red_open = false;
              _this.red_no_win = true;
              _this.grabInfo = res.data.message;
            }
          }, 1000);
        })
        .catch(() => {
          _this.showloding = false;
          _this.throttle = true;
          mui.alert("Your current network is unstable. Please optimize the network.");
        });
    },
  },
  created() {
    this.findConfigs();
    this.findLastRed();
  },
};
</script>
<style scoped lang="scss">
.scroll_content {
  background-image: url(../../assets/images/base/turnbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  .game_title {
    font-size: 35px;
  }
  .red_open {
    background-image: url(../../assets/images/game/red/red_open.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 450px;
    height: 600px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translateX(-50%) translateY(-50%);
    color: #ddbc84;
    z-index: 1;
    zoom: 100%;
    .head_img {
      height: 86px;
      img {
        width: 100px;
        margin: auto;
      }
    }
    .issue_no {
      height: 30px;
      margin-top: 5px;
      font-size: 0.34rem;
      color: #d4bc92;
    }
    .send_user {
      height: 50px;
      margin-top: 15px;
      font-size: 33px;
      color: #ddbc84;
    }
    .may_you {
      color: white;
      margin: auto;
      width: 450px;
      height: 118px;
      font-size: 28px;
      margin-top: 10px;
    }
    .show_more {
      width: 100%;
      position: absolute;
      transform: translateX(-50%);
      color: gold;
      font-size: 0.36rem;
      left: 50%;
      bottom: 86px;
    }
    .company {
      width: 90%;
      position: absolute;
      transform: translateX(-50%);
      color: rgb(208, 208, 208);
      font-size: 0.32rem;
      left: 50%;
      bottom: 50px;
    }
    .red_no_open {
      .open {
        background-image: url(../../assets/images/game/red/red_get.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 180px;
        height: 180px;
        color: #3b3b3b;
        font-size: 40px;
        margin: auto;
        margin-top: 10px;
        cursor: pointer;
        padding-top: 58px;
        zoom: 70%;
      }
    }
    .openning {
      zoom: 70%;
      position: absolute;
      left: 50%;
      top: 64%;
      transform: translateX(-50%) translateY(-50%);
      img {
        width: 180px;
      }
    }
    .red_win {
      color: white;
      .win_money {
        color: gold;
        font-size: 56px;
        padding-top: 30px;
      }
      .win_tip .t1 {
        font-size: 24px;
      }
      .win_tip .t2 {
        font-size: 0.32rem;
      }
    }
  }
  .game_right {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #3b3b3b;
    background: rgb(253, 253, 249, 40%);
    width: 500px;
    right: 0;
    text-align: center;
    font-size: 0.34rem;
    .right_title {
      color: white;
      font-size: 26px;
      padding: 10px 10px;
      height: 60px;
    }
    .right_list {
      height: 600px;
      overflow-y: auto;
      background: white;
      padding-bottom: 20px;
      ul {
        display: flex;
        justify-content: center;
        li {
          border: 0px solid rgb(124, 124, 124);
          border-bottom: 1px solid rgb(126, 125, 125, 40%);
          margin: 0 0 -1px -1px;
          padding: 5px 0;
        }
        .record-img {
          width: 16%;
          img {
            width: 60px;
          }
        }
        .red-from {
          width: 48%;
          text-align: left;
          :first-child {
            font-weight: bold;
            padding-top: 3px;
          }
          :last-child {
            font-size: 0.32rem;
            color: rgb(163, 163, 163);
            padding-top: 7px;
          }
        }
        .red-money {
          width: 16%;
          text-align: right;
          font-size: 0.36rem;
          font-weight: bold;
          color: rgb(168, 143, 1);
          padding-top: 25px;
        }
      }
    }
  }
  .game_right_m {
    display: none;
    position: absolute;
    color: #3b3b3b;
    background-image: url(../../assets/images/base/turnbg.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    font-size: 0.34rem;
    z-index: 4;
    .right_title {
      color: white;
      font-size: 30px;
      padding: 20px 10px;
      height: 80px;
    }
    .close-btn {
      position: absolute;
      right: 12px;
      top: 12px;
      z-index: 4;
      width: 50px;
      height: 50px;
      img {
        width: 50px;
      }
    }
    .right_list {
      height: 100%;
      overflow-y: auto;
      background: rgb(243, 242, 242, 100%);
      padding-bottom: 20px;
      ul {
        display: flex;
        justify-content: center;
        li {
          border: 0px solid rgb(124, 124, 124);
          border-bottom: 1px solid rgb(126, 125, 125, 40%);
          margin: 0 0 -1px -1px;
          padding: 8px 0;
        }
        .record-img {
          width: 16%;
          img {
            width: 80px;
          }
        }
        .red-from {
          width: 54%;
          text-align: left;
          :first-child {
            font-size: 23px;
            font-weight: bold;
            padding-top: 4px;
          }
          :last-child {
            font-size: 0.36rem;
            color: rgb(163, 163, 163);
            padding-top: 9px;
          }
        }
        .red-money {
          width: 16%;
          font-size: 24px;
          text-align: right;
          font-weight: bold;
          color: rgb(168, 143, 1);
          padding-top: 32px;
        }
      }
    }
  }
}
</style>